export const colors = {
  BC1: '#fff',
  BC2: '#f2f3fd',
  BC3: '#fafaf6',
  BC4: '#211c1d',
  BC5: 'rgba(0, 0, 0, 0.59)',
  BC6: 'rgba(0, 0, 0, 0.5)',
  BC7: 'rgba(0, 0, 0, 0.85)',
  BC8: '#bebebe',
  BC8a: '#cbcbcb',
  BC9: '#edeee9',
  BC10: '#211c1d',
  BC11: '#f5dccf',
  BC12: '#f4f4f4',
  BC13: '#8ab67c',
  BC14: '#0089ec',
  BC15: '#f1f1f1',

  C1: '#e7773b',
  C1a: '#ed9769',
  C1b: '#d55b1a',
  C2: '#fff',
  C2a: '#818484',
  C3: '#df4230',
  C4: '#211c1d',
  C5: '#323232',
  C6: '#fafaf6',
  C7: '#d2d2cf',
  C8: '#ff331e',
  C9: '#747474',
  C10: '#545454',
  C11: '#a6a6a6',
  C12: '#a5af4f',
  C13: '#bf393f',
  C13a: '#dec2c4',

  BD1: '#d2d2d1',
  BD2: '#5e5959',
  BD3: '#ebeae6',

  BT1: '#a5a5a5',
  BT2: '#ecbda5'
};



// WEBPACK FOOTER //
// ./styles/core/dark.colors.style.js